import { Factory } from './_factory';
import { LearningPath } from '@app/models/_index';
import { Learning_Path } from '@app/enums/_index';

/**
 * Create Learning Path Factory used by application
 * Creates instances of Learning Paths
 */
export class LearningPathFactory implements Factory<LearningPath> {
  learningPaths: LearningPath[] = [];

  /**
   * Call and build static learning paths array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static learning types array to be used to determine the Course learning type
   * Used to show and filter tooltips for a given course detail
   */
  build(): void {
    this.learningPaths.push(
      new LearningPath(
        Learning_Path.AGENT,
        'agent-learning-path',
        'Ideal for front-line contact center staff responsible for handling customer interactions through channels such as voice, chat, SMS, email, and social media'
      )
    );
    this.learningPaths.push(
      new LearningPath(
        Learning_Path.AI_ESSENTIALS,
        'ai-essentials',
        'Ideal for individuals who are responsible for the digital applications or those utilizing AI to engage with customers across both digital and voice channels'
      )
    );
    this.learningPaths.push(
      new LearningPath(
        Learning_Path.BUSINESS_USER,
        'business-user-learning-path',
        'Ideal for individuals who are responsible for managing the business operations, collaborating through chat, video conference, calls, and document sharing'
      )
    );
    this.learningPaths.push(
      new LearningPath(
        Learning_Path.DEVELOPER,
        'developer-user-learning-path',
        'Ideal for individuals who are responsible for creating web and desktop applications connected to Genesys resources through Genesys APIs, client libraries, and JavaScript APIs'
      )
    );
    this.learningPaths.push(
      new LearningPath(
        Learning_Path.SYSTEM_ADMINISTRATOR,
        'system-admin-learning-path',
        'Ideal for individuals who are responsible for the daily operation, user and group administration, callflow setup, configuration changes, and usage policies'
      )
    );
  }

  /**
   * Return immutable or copy of Learning Type collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): LearningPath[] {
    if (this.learningPaths && this.learningPaths.length === 0) {
      this.build();
    }
    return this.learningPaths.slice();
  }
}
